<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Assign Sub-driver for ride</span>
      <span class="text-light-color text-base font-normal">#{{ config.data.id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #subDriverForm="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="w-full form-group">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="subDriver"
        >Sub Driver <span class="feedback-danger-fg-color">*</span></label
      >
      <p-select
        appResetDropdownFilter
        (onChange)="calcDriverPay(selectedSubDriver, subDriverForm.value.payoutAdjustment)"
        [options]="filteredDrivers()"
        #subDriverInp="ngModel"
        required
        [(ngModel)]="selectedSubDriver"
        name="subDriver"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        placeholder="Select a driver"
        class="w-full">
        <ng-template
          #filter
          let-options="options">
          <div class="flex flex-column gap-spacing-xl">
            <div class="dropdown-search-box">
              <div
                class="p-inputgroup"
                (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()">
                <input
                  type="text"
                  pInputText
                  placeholder="Search"
                  [(ngModel)]="filterValue"
                  [ngModelOptions]="{ standalone: true }"
                  (keyup)="customFilterFunction($event, options)" />
                <span class="p-inputgroup-search"><i class="icon-magnifying-glass"></i></span>
              </div>
            </div>
            <div class="camera-filters">
              <ul class="list-none m-0 p-0 flex gap-spacing-sm">
                @for (filter of cameraStatusFilters; track $index) {
                  <li>
                    <button
                      (click)="updateCameraStatusFilter(filter.code)"
                      class="label-medium-regular py-spacing-2xs px-spacing-md radius-full border-none"
                      [ngClass]="{
                        'table-bg-head-hover-bg': !filter.selected,
                        'background-muted-brand-bg': filter.selected
                      }">
                      {{ filter.name }}
                    </button>
                  </li>
                }
              </ul>
            </div>
          </div>
        </ng-template>
        <ng-template
          #selectedItem
          let-selectedOption>
          <div class="flex align-items-center gap-spacing-xs">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template
          let-driver
          #item>
          <div class="flex justify-content-between align-items-start w-full">
            <div class="flex flex-column gap-spacing-3xs">
              <div class="title-small-medium">{{ driver.name }}</div>
              <div class="flex gap-spacing-2xs">
                <span>{{ driver.organization }}</span>
                <span>|</span>
                <span>{{ driver.mobileNumber }}</span>
              </div>
            </div>

            <span
              [pTooltip]="
                (!driver.cameraStatus?.camera_id ? 'Not Installed' : driver.cameraStatus?.camera_online_status ? 'Active' : 'Offline') +
                (driver.cameraStatus?.last_sync_date ? ' - Last Sync ' + (driver.cameraStatus.last_sync_date | date: 'h:mm a') : '')
              "
              tooltipPosition="bottom"
              [autoHide]="false"
              class="flex align-items-center gap-spacing-3xs p-spacing-3xs border-1 border-round-sm"
              [ngClass]="{
                'icon-lightest-color icon-lightest-border': driver.cameraStatus?.camera_id && !driver.cameraStatus?.camera_online_status,
                'icon-danger-color icon-danger-border': !driver.cameraStatus?.camera_id,
                'icon-success-subtle-color icon-success-subtle-border': driver.cameraStatus?.camera_id && driver.cameraStatus?.camera_online_status
              }">
              <i
                class="size-icon-sm"
                [ngClass]="{
                  'icon-video-camera-solid': driver.cameraStatus?.camera_id,
                  'icon-video-camera-slash-solid': !driver.cameraStatus?.camera_id
                }"></i>
            </span>
          </div>
        </ng-template>
      </p-select>
      @if (subDriverInp.dirty && subDriverInp.errors && subDriverInp.errors["required"]) {
        <small class="input-helper-text label-medium-regular text-danger-color"> This field is required. </small>
      }
      @if (subDriverInp.errors && subDriverInp.errors["requiresCamera"]) {
        <small class="input-helper-text label-medium-regular text-danger-color"> Cannot assign {{ selectedSubDriver?.name }} - vehicle does not have required camera. Please select a driver with a camera-equipped vehicle. </small>
      }
    </div>

    <div class="flex gap-spacing-xl flex-wrap md:flex-nowrap">
      <div class="py-spacing-xs w-full px-spacing-md flex flex-column border-1 border-neutral-base-primary-border border-round-md bg-white">
        <span class="title text-xs text-light-color font-medium">RIDE MILAGE</span>
        <span class="value text-sm text-secondary-color font-medium">{{ config.data.rideMilage }}mi</span>
      </div>
      <div class="py-spacing-xs w-full px-spacing-md flex flex-column border-1 border-neutral-base-primary-border border-round-md bg-white">
        <span class="title text-xs text-light-color font-medium">RIDE DURATION</span>
        <span class="value text-sm text-secondary-color font-medium">{{ config.data.rideDuration }} mins</span>
      </div>
    </div>

    <div class="form-group">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="payoutAdjustment"
        >Payout Adjustment</label
      >
      <div class="k-input-wrapper">
        <em class="left-icon icon-currency-dollar"></em>
        <p-inputNumber
          class="w-full p-inputtext-sm"
          #payoutAdjustment
          [(ngModel)]="payoutAdjustmentVal"
          (onInput)="calcDriverPay(selectedSubDriver, subDriverForm?.value?.payoutAdjustment)"
          name="payoutAdjustment"
          inputId="payoutAdjustment"
          mode="decimal"
          placeholder="0.00"
          [style]="{ width: '100%' }"
          [maxFractionDigits]="2" />
      </div>
    </div>

    <div class="flex gap-spacing-xl flex-wrap md:flex-nowrap">
      <div class="w-full form-group">
        <label
          class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
          for="providerTotalPay"
          >Driver Provider Total Pay</label
        >
        <div class="k-input-wrapper">
          <em class="left-icon icon-currency-dollar"></em>
          <p-inputNumber
            class="w-full p-inputtext-sm"
            #providerTotalPayInp
            readonly
            [(ngModel)]="providerTotalPay"
            name="providerTotalPay"
            inputId="providerTotalPay"
            mode="decimal"
            placeholder="0.00"
            [style]="{ width: '100%' }"
            [maxFractionDigits]="2" />
        </div>
      </div>
      <div class="w-full form-group">
        <label
          class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
          for="driverTotalPay"
          >Driver Total Pay</label
        >
        <div class="k-input-wrapper">
          <em class="left-icon icon-currency-dollar"></em>
          <p-inputNumber
            class="w-full p-inputtext-sm"
            #driverTotalPayInp
            readonly
            [(ngModel)]="driverTotalPay"
            name="driverTotalPay"
            inputId="driverTotalPay"
            mode="decimal"
            placeholder="0.00"
            [style]="{ width: '100%' }"
            [maxFractionDigits]="2" />
        </div>
      </div>
    </div>

    @if (oldDriverData) {
      <div class="old-driver-info border-round-md border-1 border-feedback-info-border background-muted-info-bg p-spacing-md flex gap-spacing-xs">
        <i class="icon-info-solid icon-info-color size-icon-xl"></i>
        <p class="mb-0 label-large-regular text-info-color">
          <span class="label-large-bold">Heads Up! </span>
          This ride was assigned to
          <span class="label-large-bold"> {{ oldDriverData.driverName }} </span>
          from
          <span class="label-large-bold"> {{ oldDriverData.driverProvider }}</span>
          with a total adjustment of {{ oldDriverData.payoutAdjustment }}, and provider total amount of <span class="label-large-bold">${{ oldDriverData.driverProviderPayout | number: "1.2-2" }} </span>, and driver total amount of
          <span class="label-large-bold">${{ oldDriverData.driverPayout | number: "1.2-2" }}</span>
        </p>
      </div>
    }

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex gap-spacing-default font-medium"
        for="reasonInput"
        >Reason <span class="feedback-danger-fg-color">*</span></label
      >
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        name="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        [showEmptyMessage]="false"
        [minLength]="0"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason."
        appendTo="body" />
      @if (reasonInput.dirty && reasonInput.errors && reasonInput.errors["required"]) {
        <small class="input-helper-text label-medium-regular feedback-danger-fg-color">This field is required.</small>
      }
    </div>
  </form>

  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid icon-warning-color text-xl"></i>
    <ul class="mb-0 pl-spacing-2xs list-none">
      <li class="label-large-regular text-warning-color">This action will notify the driver and any monitors via push Notification.</li>
    </ul>
  </div>

  <div class="flex align-items-center">
    <p-checkbox
      [(ngModel)]="notifyChecked"
      [binary]="true"
      inputId="notify"></p-checkbox>
    <label
      class="p-checkbox-label cursor-pointer label-large-regular form-label-color"
      for="notify">
      By Selecting this box, this action will notify Guardians via push notification.
    </label>
  </div>

  <!-- Same driver alert -->
  <p-dialog
    [showHeader]="false"
    [modal]="true"
    [draggable]="false"
    [(visible)]="showAlert"
    [style]="{ width: '400px' }">
    <div class="p-dialog-header px-0 flex flex-column align-items-end gap-spacing-md pb-spacing-none">
      <div class="p-dialog-title">
        <div class="flex gap-spacing-xs align-items-center">
          <span class="title-small-bold text-primary-color">The selected driver is the same as the ride's old driver.</span>
        </div>
      </div>
    </div>

    <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-center gap-spacing-xl">
      <app-button
        label="Ok, got it."
        [disabled]="loading"
        [outlinedButton]="true"
        (btnClick)="showAlert = false"
        sizeClass="p-button-md"
        severity="primary"></app-button>
    </div>
  </p-dialog>

  <!-- Confirm action dialog -->
  <p-dialog
    [showHeader]="false"
    [modal]="true"
    [draggable]="false"
    [(visible)]="confimActionVisible"
    [style]="{ width: '400px' }">
    <div class="p-dialog-header px-0 flex flex-column align-items-start gap-spacing-md pb-spacing-md">
      <div class="flex justify-content-between gap-spacing-xs w-full">
        <span class="background-muted-warning-bg flex p-spacing-xs border-round-md">
          <i class="icon-warning-circle-solid text-xl icon-warning-color"></i>
        </span>
        <div class="p-dialog-header-icons">
          <app-button
            (btnClick)="confimActionVisible = false"
            [iconOnlyButton]="true"
            icon="icon-x"
            sizeClass="p-button-sm"
            severity="secondary"
            [textButton]="true"></app-button>
        </div>
      </div>

      <div class="p-dialog-title">
        <div class="flex gap-spacing-xs align-items-center">
          <span class="title-small-bold text-primary-color">Assign Sub-driver Confirmation</span>
        </div>
      </div>
    </div>

    <div class="flex flex-column gap-spacing-xs">
      <span class="flex flex-wrap align-items-center gap-spacing-2xs label-medium-medium text-caption-color">
        This Ride Blueprint
        <app-tag
          iconStart="icon-blueprint"
          [content]="config.data.blueprintId"
          styleClass="bold"
          sizeClass="tag-sm"
          severityClass="help"></app-tag>
        Require the following:
      </span>

      @if (config.data.ridePassengerEquipments?.length > 0 || config.data.blueprintVehicleType) {
        <div class="bp-equipments flex flex-column gap-spacing-2xs">
          @for (e of config.data.ridePassengerEquipments; track $index) {
            <app-tag
              iconStart="icon-check-circle-solid"
              [content]="e.name"
              sizeClass="tag-sm"
              severityClass="info"></app-tag>
          }

          @if (config.data.blueprintVehicleType) {
            <app-tag
              iconStart="icon-check-circle-solid"
              [content]="config.data.blueprintVehicleType"
              sizeClass="tag-sm"
              severityClass="info"></app-tag>
          }
        </div>
      }

      @if (driverMeetsRequirements) {
        <span class="label-medium-medium text-caption-color"> Are you sure you want to assign this driver? This action is permanent. </span>
      } @else {
        <span class="label-medium-medium text-caption-color"> And {{ selectedSubDriver?.name }} doesn’t meet these requirements, Are you sure you want to assign this driver? </span>
      }
    </div>

    <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
      <app-button
        label="Close"
        (btnClick)="confimActionVisible = false"
        sizeClass="p-button-md"
        severity="secondary"></app-button>
      <app-button
        label="Proceed"
        [disabled]="loading"
        (btnClick)="confirmAction()"
        sizeClass="p-button-md"
        severity="warning"></app-button>
    </div>
  </p-dialog>
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    [disabled]="!subDriverForm.valid || loading || reasonInput.value?.trim().length <= 0"
    label="Assign New Driver"
    (btnClick)="validateAction()"
    sizeClass="p-button-md"
    severity="primary">
  </app-button>
</div>
